import * as React from 'react';
import styled, { css } from 'styled-components';

const Typography = css`
    line-height: 1.5em;
`;

/**
 * @deprecated use JRCTypography instead
 * Props Type for JRCH1
 * @see HTML.H1 props
 */
export type JRCH1Props = React.ComponentPropsWithoutRef<'h1'>;
const JRCH1 = styled.h1<JRCH1Props>`
    ${Typography};
    font-size: 32px;
`;

/**
 * @deprecated use JRCTypography instead
 * Props Type for JRCH2
 * @see HTML.H2 props
 */
export type JRCH2Props = React.ComponentPropsWithoutRef<'h2'>;

const JRCH2 = styled.h2<JRCH2Props>`
    ${Typography};
    font-size: 24px;
`;

/**
 * @deprecated use JRCTypography instead
 * Props Type for JRCH3
 * @see HTML.H3 props
 */
export type JRCH3Props = React.ComponentPropsWithoutRef<'h3'>;
const JRCH3 = styled.h3<JRCH3Props>`
    ${Typography};
    font-size: 18px;
`;

/**
 * @deprecated use JRCTypography instead
 * Props Type for JRCH4
 * @see HTML.H4 props
 */
export type JRCH4Props = React.ComponentPropsWithoutRef<'h3'>;
const JRCH4 = styled.h4<JRCH4Props>`
    ${Typography};
    font-size: 16px;
    font-weight: bold;
`;

/**
 * @deprecated use JRCTypography instead
 * Props Type for JRCH5
 * @see HTML.H5 props
 */
export type JRCH5Props = React.ComponentPropsWithoutRef<'h5'>;
const JRCH5 = styled.h5<JRCH5Props>`
    ${Typography};
    font-size: 16px;
    text-transform: uppercase;
`;

/**
 * @deprecated use JRCTypography instead
 * Props Type for JRCText
 * @member size: optionnal size of the text 's'|'m'|'l'
 */
export interface JRCTextProps {
    /** Size of the text */
    size?: 's' | 'm' | 'l';
}

const sizeMap = new Map([
    ['s', '12px'],
    ['m', '14px'], // default
    ['l', '16px'],
]);

const Text = css<JRCTextProps>`
    ${Typography};
    font-size: ${(props) => sizeMap.get(props.size || 'm')};
`;

const JRCText = styled.p<JRCTextProps>`
    ${Text};
`;

export { JRCH1, JRCH2, JRCH3, JRCH4, JRCH5, Text, JRCText };
